export const hopintoReducerKey = 'hopintoReactGlobal';
export const setFullTextDocumentIdType = 'HOPINTO_SET_FULL_TEXT_DOCUMENT_ID_TYPE';
